import React, { useState } from "react";
import styled from "styled-components";
import API from "../../../util/api";
import ConfirmationModal from "../../Common/ConfirmationModal";

const Container = styled.div`
  padding: 1.5em;
  background: transparent;

  @media (max-width: 600px) {
    padding: 1em;
    width: 400px;
  }
`;

const Form = styled.form`
  background: ${({ colors }) => colors.cardBackground};
  padding: 1.5em;
  border-radius: 4px;
  max-width: 400px;

  @media (max-width: 600px) {
    width: 100%;
    max-width: 420px;
  }

  @media (max-width: 480px) {
    padding: 1.25em;
    width: 400px;
  }
`;

const Field = styled.div`
  margin-bottom: 1em;

  label {
    display: block;
    margin-bottom: 0.5em;
    font-size: 0.95em;
    color: ${({ colors }) => colors.labelText};
    font-weight: bold;
  }
`;

const StyledInput = styled.input`
  width: 800px;
  padding: 0.6em;
  font-size: 1em;
  border: 2px solid ${({ colors }) => colors.buttonBackground};
  border-radius: 4px;
  background-color: ${({ colors }) => colors.cardBackground};
  color: ${({ colors }) => colors.labelText};

  @media (max-width: 600px) {
    width: 400px;
  }

  @media (max-width: 480px) {
    font-size: 0.95em;
    width: 400px;
  }
`;

const SubmitRow = styled.div`
  margin-top: 1em;

  input[type="submit"] {
    padding: 0.6em 1.2em;
    background: ${({ colors }) => colors.buttonBackground};
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 1em;
    cursor: pointer;

    &:hover {
      background: ${({ colors }) => colors.buttonHoverBackground};
    }
  }
`;

export default function MergeAccountsContent({ colors }) {
  const [primary, setPrimary] = useState("");
  const [secondary, setSecondary] = useState("");

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [resultOpen, setResultOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [modalStatus, setModalStatus] = useState("Success");


  const onSubmit = (e) => {
    e.preventDefault();
    setConfirmOpen(true);
  };


  const handleConfirm = async () => {
    setConfirmOpen(false);
    setModalStatus("Success");
    try {
      const resp = await API.adminMergeAccount({ primary, secondary });
      const status = resp?.status === "Failed" ? "Failed" : "Success";
      setModalTitle(status === "Failed" ? "Error" : "Success");
      setModalMessage(resp?.message || (status === "Failed" ? "Failed to merge accounts." : "Accounts merged successfully."));
      setModalStatus(status);
      if (status === "Success") {
        setPrimary("");
        setSecondary("");
      }
    } catch (err) {
      console.error(err);
      setModalTitle("Error");
      setModalMessage("An unexpected error occurred.");
      setModalStatus("Failed");
    }
    setResultOpen(true);
  };

  const handleResultClose = () => {
    setResultOpen(false);
    setModalStatus("Success");
  };

  return (
    <Container>
      {/* Confirm before merge */}
      <ConfirmationModal
        show={confirmOpen}
        title="Please confirm"
        message="Merge these two accounts?"
        onCancel={() => setConfirmOpen(false)}
        onConfirm={handleConfirm}
      />

      {/* Show result */}
      <ConfirmationModal
        show={resultOpen}
        title={modalTitle}
        message={modalMessage}
        onCancel={handleResultClose}
        onConfirm={handleResultClose}
        status={modalStatus}
      />

      <Form id="mergeaccountsForm" onSubmit={onSubmit} colors={colors}>
        <Field colors={colors}>
          <label style={{fontWeight: 'bolder'}} htmlFor="primary">Primary Email</label>
          <StyledInput
            id="primary"
            name="primary"
            type="email"
            value={primary}
            onChange={(e) => setPrimary(e.target.value)}
            colors={colors}
            required
          />
        </Field>

        <Field colors={colors}>
          <label style={{fontWeight: 'bolder'}} htmlFor="secondary">Secondary Email</label>
          <StyledInput
            id="secondary"
            name="secondary"
            type="email"
            value={secondary}
            onChange={(e) => setSecondary(e.target.value)}
            colors={colors}
            required
          />
        </Field>

        <SubmitRow colors={colors}>
          <input type="submit" value="Submit" />
        </SubmitRow>
      </Form>
    </Container>
  );
}
